import React, { useState, useEffect, useRef } from "react";
import * as assetsAction from "../../../redux/actions/assetsAction";
import { useDispatch, useSelector } from "react-redux";
import {
  API_STATUS,
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
} from "../../../constant/constant";
import {
  ACCESS_DENIED,
  ADMIN_ADD_ASSETS,
  ADMIN_ASSETS,
} from "../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import AssetList from "../component/assets/assetList";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { toast, ToastContainer } from "react-toastify";
import { InactiveClient } from "../../../utils/helper";
import { getPreviousRoute } from "../../../utils/routeTracker";
export default function AssetsContainer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assetList = useSelector((state) => state.assetList);
  const assetListDelete = useSelector((state) => state.deleteAsset.status);
  const [sendEmail, setSendEmail] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);
  const deleteTriggeredRef = useRef(false);
  const showLoader = useSelector(
    (state) => state.assetList?.isLoading || state.deleteAsset.isLoading,
  );

  useEffect(() => {
    if (assetListDelete === "SUCCESS" && deleteTriggeredRef.current) {
      deleteTriggeredRef.current = false;
      const currentFilter = assetList?.filterObj || defaultData;
      getAssetList(currentFilter);
    }
  }, [assetListDelete]);

  const clientDivision = useSelector((state) => state.getDropdownDataKeyValue);

  const assetCategory = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.assetTypes,
  );
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const divisions = userInfo?.divisions?.filter(
    (i) => i?.serviceType == PRODUCT_ID(),
  );
  const isClient = userInfo?.isClient;

  const [clientDivisions, setClientDivisions] = useState();
  const valueCheck = clientDivisions || divisions;
  const clientSwitch = isClient || ORG_ID() !== LOGIN_ORG_ID();

  useEffect(() => {
    if (clientSwitch) {
      if (clientDivision?.status === API_STATUS.SUCCESS) {
        const divisions = clientDivision?.data?.divisons && [
          ...clientDivision?.data?.divisons,
        ];
        divisions?.unshift({ key: "AllDivision", value: "All Divisions" });
        setClientDivisions(divisions);
      }
    }
  }, [clientDivision, clientSwitch]);

  const defaultData = {
    page: 1,
    divisionId: clientSwitch && valueCheck ? 0 : divisions[0]?.key,
    pageSize: PAGE_SIZE,
    statusIds: "",
    isSendMail: false,
    search: "",
    userId: 0,
    organisationId: ORG_ID(),
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_ADD_ASSETS];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("assetListPreserveState") === "true";
    sessionStorage.removeItem("assetListPreserveState");

    dispatch(assetsAction.clearAsset());
    if (isFromPreserveRoute && assetList?.filterObj) {
      setShouldRestoreState(true);
      getAssetList(assetList.filterObj);
    } else {
      setShouldRestoreState(false);
      getAssetList(defaultData);
    }
  }, []);

  const getAssetList = (data) => {
    dispatch(assetsAction.getAssetList(data));
    dispatch(assetsAction.getCustomAssetsFilterObj(data));
  };

  const addAsset = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_ASSETS);
  };

  const handleDeleteAsset = (assetId) => {
    if (InactiveClient()) return;
    deleteTriggeredRef.current = true;
    dispatch(assetsAction.deleteAsset(assetId));
  };
  function getAssetListData(data) {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(assetsAction.getAssetList(data));
    dispatch(assetsAction.getCustomAssetsFilterObj(data));
  }

  useEffect(() => {
    const getDropdownDataKeyValueData = {
      orgId: ORG_ID(),
      flags: [6, 13],
      productId: PRODUCT_ID(),
    };
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    if (assetList?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Assets has been sent to registered email ID");
    }
  }, [assetList]);

  return (
    <>
      {checkPrivileges([12, 37, 38, 39]) ? (
        <>
          <ToastContainer />
          <AssetList
            assetList={showLoader ? [] : assetList?.data}
            getContactListData={getAssetList?.data?.users}
            isAssetLoading={showLoader}
            addContact={addAsset}
            getAssetListData={getAssetListData}
            assetListData={assetList}
            divisionDropdown={
              clientSwitch && valueCheck ? clientDivisions : divisions
            }
            assetCategory={assetCategory ?? []}
            isShowDowdownloadButton={true}
            shouldRestoreState={shouldRestoreState}
            handleDeleteAsset={handleDeleteAsset}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
}
